import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useToken } from "./TokenContext";
import "../css/useraccess.css";

const UserAccess = () => {
  const [tokenInput, setTokenInput] = useState("");
  const { login } = useAuth();
  const { setLoggedInToken, setLoggedInUser, setLocationNames, setUserRole, setUserName, setCompanyName } = useToken();
  const navigate = useNavigate();

  
  useEffect(() => {
    //ローカルストレージ削除
    Object.keys(localStorage).forEach((key) => {
        localStorage.removeItem(key);
    });
    // ✅ postMessage でトークン受信処理
    const handler = (event) => {
      if (event.origin !== "https://curriculum.myou-kou.com") return;
      if (event.data?.type === "SET_TOKEN" && event.data?.token) {
        setTokenInput(event.data.token);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  // ✅ Lambda API によるトークン検証
  const validateToken = async (inputToken) => {
    try {
      const res = await fetch("https://mpzzlvohx7.execute-api.ap-northeast-3.amazonaws.com/prod/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "validate-token", token: inputToken }),
      });

      const data = await res.json();
      if (!data.valid) return { isValid: false, message: data.message };

      return {
        isValid: true,
        recipient: data.recipient,
        name: data.name,
        role: data.role,
        companyName: data.companyName,
        locationNames: data.locationNames || [], // 拠点名の配列
        expiresAt: data.expiresAt,
      };
    } catch (err) {
      return { isValid: false, message: "サーバーエラーが発生しました" };
    }
  };

  // ✅ トークン送信＆認証処理
  const handleTokenSubmit = async () => {
    const validation = await validateToken(tokenInput);

    if (validation.isValid) {
      localStorage.setItem("accessExpiry", new Date(validation.expiresAt).getTime());
      localStorage.setItem("userAffiliation", validation.recipient);
      localStorage.setItem("loggedInToken", tokenInput);
      localStorage.setItem("userName", validation.name);
      localStorage.setItem("userRole", validation.role);
      localStorage.setItem("companyName_findjob", validation.companyName);
      if (validation.locationNames) {
        localStorage.setItem("locationNames", JSON.stringify(validation.locationNames));
      }

      // TokenContextに値を設定
      setLoggedInUser(validation.recipient);
      setLoggedInToken(tokenInput);
      setUserName(validation.name);
      setUserRole(Number(validation.role)); // 数値として設定
      setCompanyName(validation.companyName);
      if (validation.locationNames) {
        setLocationNames(validation.locationNames);
      }
      login();

      // 拠点名をフォーマット（複数所属の場合は列挙）
      const locationText = validation.locationNames && validation.locationNames.length > 0
        ? validation.locationNames.join('、')
        : validation.companyName || '';

      alert(`✅ 認証成功：${validation.name}（${locationText}）`);

      // React Routerのnavigateを使用してリダイレクト（ページ再読み込みなし）
      navigate("/nameinput", { replace: true });
    } else {
      alert(`❌ 認証失敗: ${validation.message}`);
    }
  };

  // ✅ セッション有効期限チェック
  useEffect(() => {
    const checkTokenStatus = () => {
      const expiry = localStorage.getItem("accessExpiry");
      const token = localStorage.getItem("loggedInToken");
      if (!expiry || !token) return;

      const expiryTime = parseInt(expiry, 10);
      if (Date.now() > expiryTime) {
        alert("⏰ トークンの有効期限が切れました。ログアウトします。");
        localStorage.clear();
        navigate("/");
      }
    };

    const timer = setTimeout(checkTokenStatus, 1000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">トークン認証ページ</div>
        <div className="card-content">
          <input
            id="token-input"
            type="text"
            placeholder="トークン入力 (XXXX-XXXX-XXXX)"
            value={tokenInput}
            onChange={(e) => setTokenInput(e.target.value)}
            className="token-input"
          />
          <button onClick={handleTokenSubmit} className="login-button">
            トークン認証
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserAccess;
